module.exports = __webpack_public_path__ + "static/img/ic_up.57dad79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/ic_up.svg
// module id = k3s6
// module chunks = 10